import { render } from "./BookShelf.vue?vue&type=template&id=37ae2795"
import script from "./BookShelf.vue?vue&type=script&lang=js"
export * from "./BookShelf.vue?vue&type=script&lang=js"

import "./BookShelf.vue?vue&type=style&index=0&id=37ae2795&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__